/** Which media entity supplies `created_date` when ordering library cards (newest first). */
export type LibrarySortMediaKind = "image" | "video";

export interface LibrarySortEntityRef {
  readonly kind: LibrarySortMediaKind;
  readonly assetId: string;
}

export interface LibraryItemSortKeySource {
  readonly imageId: string;
  readonly libraryVideoId?: string;
}

export function librarySortEntityRef(item: LibraryItemSortKeySource): LibrarySortEntityRef {
  const vid = item.libraryVideoId;

  if (typeof vid === "string" && vid.trim() !== "") {
    return { kind: "video", assetId: vid.trim() };
  }

  return { kind: "image", assetId: item.imageId };
}

export function librarySortEntityCacheKey(ref: LibrarySortEntityRef): string {
  return `${ref.kind}:${ref.assetId}`;
}
